import React from "react";
import { matchPath } from "react-router-dom";
import SidebarPageItem from "./sidebar-page-item";
import { SidebarItem } from "./sidebar-elements";
import useCanShowItem from "./use-can-show-item";

interface NestedItemProps {
  item: SidebarItem;
  mini: boolean;
  isFullyExpanded: boolean;
  expanded: boolean;
  pathname: string;
  handlePageItemClick: (id: string, hasNested: boolean) => void;
}

const NestedItem: React.FC<NestedItemProps> = ({
  item,
  mini,
  isFullyExpanded,
  expanded,
  pathname,
  handlePageItemClick,
}) => {
  const canShowItem = useCanShowItem();

  if (
    !canShowItem({
      requiredPermission: item.requiredPermission,
      ldFlag: item.ldFlag,
    })
  )
    return null;

  return (
    <SidebarPageItem
      item={item}
      selected={!!matchPath(`${item.href}/*`, pathname)}
      defaultExpanded={!!matchPath(`${item.href}/*`, pathname)}
      expanded={expanded}
      mini={mini}
      fullyExpanded={isFullyExpanded}
      fullyCollapsed={!expanded}
      onToggle={() => handlePageItemClick(item.id, false)}
    />
  );
};

export default React.memo(NestedItem);
